import React from 'react';

function ProgressRing({ value, size = 52 }) {
  return (
    <div
      className="progress-ring"
      style={{
        '--progress': `${value * 3.6}deg`,
        '--size': `${size}px`
      }}
      aria-label={`${value}% complete`}
    >
      <span>{value}%</span>
    </div>
  );
}

export default ProgressRing;